import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
    const [cartItems, setCartItems] = useState(() => {
        const savedCart = typeof window !== 'undefined' ? localStorage.getItem('cart') : null;
        return savedCart ? JSON.parse(savedCart) : [];
    });

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cartItems));
    }, [cartItems]);

    const [isCartOpen, setIsCartOpen] = useState(false);
    
    const clearCart = () => {
        setCartItems([])
    }

    const calculateBulkPrice = (product, quantity) => {
        if (!product.bulkDiscounts || product.bulkDiscounts.length === 0) {
            return quantity * product.price;
        }
    
        let remainingQty = quantity;
        let totalPrice = 0;
    
        const sortedDiscounts = [...product.bulkDiscounts].sort((a, b) => a.quantity - b.quantity);
    
        while (remainingQty > 0) {
            let appliedDiscount = false;
    
            for (let i = sortedDiscounts.length - 1; i >= 0; i--) {
                const discount = sortedDiscounts[i];

                if (remainingQty >= discount.quantity) {
                    totalPrice += discount.price;
                    remainingQty -= discount.quantity;
                    appliedDiscount = true;
                    break;
                }
            }
    
            if (!appliedDiscount) {
                totalPrice += product.price;
                remainingQty -= 1;
            }
        }
    
        return totalPrice;
    };
    
    const addToCart = (product) => {
        setCartItems(prevItems => {
            const existingItem = prevItems.find(item => item._id === product._id);
    
            if (existingItem) {
                const newQuantity = existingItem.quantity + 1;
                return prevItems.map(item =>
                    item._id === product._id
                        ? { ...item, quantity: newQuantity, totalPrice: calculateBulkPrice(product, newQuantity) }
                        : item
                );
            }
    
            return [...prevItems, { ...product, quantity: 1, totalPrice: calculateBulkPrice(product, 1) }];
        });
    };
    
    const incrementItem = (productId) => {
        setCartItems(prevItems =>
            prevItems.map(item =>
                item._id === productId
                    ? { ...item, quantity: item.quantity + 1, totalPrice: calculateBulkPrice(item, item.quantity + 1) }
                    : item
            )
        );
    };
    
    const decrementItem = (productId) => {
        setCartItems(prevItems =>
            prevItems
                .map(item =>
                    item._id === productId
                        ? { ...item, quantity: item.quantity - 1, totalPrice: calculateBulkPrice(item, item.quantity - 1) }
                        : item
                )
                .filter(item => item.quantity > 0)
        );
    };
    

    const removeFromCart = (productId) => {
        setCartItems(prevItems => 
            prevItems.filter(item => item._id !== productId)
        );
    };
    
    const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

    return (
        <CartContext.Provider 
            value={{
                cartItems,
                cartCount,
                isCartOpen,
                setIsCartOpen,
                addToCart,
                removeFromCart,
                incrementItem,
                decrementItem,
                clearCart
            }}
        
        >
            {children}
        </CartContext.Provider>
    )
}

export const useCart = () => useContext(CartContext);